export enum CyberplanConfigType {
  SMB = "SMB",
  Enterprise = "ENTERPRISE",
  ServiceProvider = "SERVICE_PROVIDER"
}
